import React, { useRef, useState, useCallback } from 'react'
import { useDisclosure, IconButton } from '@chakra-ui/react'
import { HamburgerIcon } from '@chakra-ui/icons'
import './App.css'
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme'
import Slider from './components/molecules/Slider'
import Home from './components/atoms/Home'
import Sidebar from './components/atoms/Sidebar'
import Index from './components/atoms/Index'
import guideData from '../src/constants/steps.json'

function App() {
  // --- Hooks -----------------------------------------------------------------
  const { isOpen, onOpen, onClose } = useDisclosure()
  // --- END: Hooks ------------------------------------------------------------

  // --- Local state -----------------------------------------------------------
  const [path, setPath] = useState('')
  const [slide, setSlide] = useState(0)
  // --- END: Local state ------------------------------------------------------

  // --- Data and handlers -----------------------------------------------------
  const linkHandler = useCallback((stepString: string, step: number) => {
    setSlide(step)
    setPath(stepString)
    onClose()
  }, [])

  const onNextClick = useCallback(() => {
    if (slide < guideData.length - 1) setSlide(slide + 1)
  }, [slide])

  const onPreviousClick = useCallback(() => {
    if (slide > 0) setSlide(slide - 1)
  }, [slide])
  // --- END: Data and handlers ------------------------------------------------

  // --- Refs ------------------------------------------------------------------
  const btnRef = useRef<HTMLButtonElement>(null)
  // --- END: Refs -------------------------------------------------------------

  return (
    <ChakraProvider theme={theme}>
      <div className="App bg-black w-screen text-white h-screen overflow-y-scroll snap-y snap-mandatory overscroll-y-contain overflow-x-hidden">
        <Home />
        <div className="snap-start h-screen relative">
          <div className="fixed left-0 top-0 m-4 z-[1000]">
            <IconButton
              size="xl"
              fontSize="30px"
              aria-label="back"
              variant="link"
              icon={<HamburgerIcon />}
              onClick={onOpen}
            />
          </div>
          <Sidebar isOpen={isOpen} onClose={onClose} btnRef={btnRef}>
            <Index path={path} setPath={linkHandler} />
          </Sidebar>
          <Slider
            onNextClick={onNextClick}
            onPreviousClick={onPreviousClick}
            slide={slide}
          />
        </div>
      </div>
    </ChakraProvider>
  )
}

export default App
